export const DEFAULT_INVOICE_PAYMENT_TERM = 30
